import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notification-actions" }

import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

const notifId = (): string => String(props.detail.id);

async function doResend(): Promise<void> {
    if (!window.confirm('Переотправить уведомление?')) return;
    await request({
        method: 'post',
        url: `/admin-api/notifications/${notifId()}/resend/`,
        data: {},
    });
    window.alert('Уведомление поставлено в очередь на переотправку.');
    window.location.reload();
}

async function doMarkAsSent(): Promise<void> {
    const externalId = window.prompt('Введите внешний ID (необязательно):') ?? '';
    if (externalId === null) return;
    await request({
        method: 'post',
        url: `/admin-api/notifications/${notifId()}/mark-as-sent/`,
        data: { external_id: externalId },
    });
    window.location.reload();
}

async function doSoftDelete(): Promise<void> {
    if (!window.confirm('Мягко удалить уведомление? Действие необратимо.')) return;
    await request({
        method: 'post',
        url: `/admin-api/notifications/${notifId()}/soft-delete/`,
        data: {},
    });
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn",
      onClick: doResend
    }, "Переотправить"),
    _createElementVNode("button", {
      class: "btn",
      onClick: doMarkAsSent
    }, "Отметить как отправленное"),
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: doSoftDelete
    }, "Мягкое удаление")
  ]))
}
}

})